module.exports = __webpack_public_path__ + "static/img/m_Deyubg_01.a5cbf946.jpg";